/**
 * api接口的统一出口
 */
import BASE from "./base"; // 导入接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
const apply = {
    // 补贴
    // 查询补贴
    subsidySome(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/qualifications/some/user`, params);
    },
    // 补贴短信
    subsidyCode(params) {
        return axios.post(`${BASE.ZCT_API}//subsidy/request/send/message`, params);
    },
    // 本人申请补贴
    subsidyAdd(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/request`, params);
    },
    // 提交申请补贴
    subsidySubmit(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/request/submit`, params);
    },
    // 代申请补贴
    subsidyProxy(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/request/proxy`, params)
    },
    // 代申请人人脸
    subsidyProxyFace(params) {
        return axios.post(`${BASE.ZCT_API}/faceVerify/zctuser/ocr/idcard/valid/face`, params)
    },
    // 我的补贴列表
    subsidyList(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/request/some/mine`, params);
    },
    // 他人再提交信息详情
    subsidyProxyDetail(params) {
        return axios.post(`${BASE.ZCT_API}/subsidy/getSubsidyDetailById`, params)  
    },
    // 贷款,
    // 农户贷信息
    getLoanInfo(params) {
        return axios.get(`${BASE.ZCT_API}/loan/apply/detail`, params);
    },
    // 提交农户贷信息
    getLoanApply(params) {
        return axios.post(`${BASE.ZCT_API}/loan/apply/list`, params);
    },
    // 贷款所需文件信息
    getLoanFiles(params) {
        return axios.post(`${BASE.ZCT_API}/loanApprovalFile/selectNewestLoanApprovalFile`, params);
    },
    // 贷款所需文件
    getProcessFiles(params) {
        return axios.post(`${BASE.ZCT_API}/roleFileTypeConfig/getProcessFiles`, params);
    },
    // 贷款银行列表
    loanBankList(params) {
        return axios.post(`${BASE.ZCT_API}/company/getCompanyList`, params);
    },
    // 贷款产品列表
    loanProductList(params) {
        return axios.post(`${BASE.ZCT_API}/loanProducts/getLoanProductsList`, params);
    },
    // 提交贷款申请
    loanAdd(params) {
        return axios.post(`${BASE.ZCT_API}/loanApproval/insertLoanApproval`, params);
    },
    // 我的贷款列表
    loanList(params) {
        return axios.post(`${BASE.ZCT_API}/loanApproval/getLoanApprovalList`, params);
    },
    // 我的贷款通过详情
    loanDetail(params) {
        return axios.post(`${BASE.ZCT_API}/loanApproved/selectById`, params);
    },
    // 我的贷款补充资料
    loanAddFile(params) {
        return axios.post(`${BASE.ZCT_API}/loanAddFile/insertLoanAddFile`, params);
    },

    // 企业抵押贷款
    // 进行企业贷款前，获取企业已有的信息
    getCompanyInfo(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/getCompanyInfoByApplyId`, params);
    },
    // 获取所属行业下拉数据
    getIndustryList(params){
        return axios.post(`${BASE.ZCT_API}/dictionary/getByCategoryName`,params);
    },
    // 添加企业抵押贷款记录
    addCompanyLoad(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/insertCompanyMortgageApproval`,params);
    },
    // 我的贷款- 抵押贷款列表 - 不用
    checkMortgageLoadList(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/selectPage`, params);
    },
    // 企业抵押贷款 当status为4 通过时，可查看的详情 - 不用
    mortgageLoanDetail(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/selectById`, params);
    },
    // 添加个人抵押贷款记录
    addPersonMortgageLoan(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/insertPersonalMortgageApproval`, params);
    },
    // 抵押贷款 审批状态为 补充资料时， 提交补充资料的接口
    replenishMortgageFile(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApprovalAddFile/submit`, params);
    },
    // 抵押贷款 审批状态为 通过时， 调用的接口
    passedMortgageDetail(params){
        return axios.post(`${BASE.ZCT_API}/mortgageApproval/getMortgageApprovalById`,params);
    },
    // 添加摘牌方式授权审批 --小芳
   approvalAdd(params){
        return axios.post(`${BASE.ZCT_API}/delistingAuthApproval/add`, params);
    },
    // 查询当前企业是否可用其他方式摘牌 --小芳
    getAuthInfo(params){
        return axios.post(`${BASE.ZCT_API}/delistingAuthApproval/getAuthInfo`, params);
    },
    // 云支付--高峰
    perPay(params){
        return axios.post(`${BASE.ZCT_API}/common/cloudPay/perPay`, params);
    },
    // 校验云支付--高峰
    confirm(params){
        return axios.post(`${BASE.ZCT_API}/common/cloudPay/confirm`, params);
    },
};

export default apply;
